// Generated by purs version 0.13.0
"use strict";
var gainXp = function (xp) {
    return function (player) {
        return {
            pos: player.pos,
            stats: player.stats,
            turn: player.turn,
            inventory: player.inventory,
            level: {
                currentLevel: player.level.currentLevel,
                currentXp: player.level.currentXp + xp | 0
            },
            equipment: player.equipment
        };
    };
};
module.exports = {
    gainXp: gainXp
};
